module.exports = __webpack_public_path__ + "static/media/protect.822a219e.svg";